// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/FormasPagamentoFranquia_SalvarInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /config/formas_pagamento_franquias/salvar
 *
 * Grava a aplicação inteira da forma na franquia (chamado 2026-0023): campo null herda o padrão
 * global. Só guarda taxas — nenhum cálculo as lê, a taxa do recebimento continua informada nele ou
 * vinda do gateway.
 */
import { registerContract } from './validate'

export interface FormasPagamentoFranquia_SalvarInput {
forma_pagamento_id: number
franquia_id: number
fpf_possui_taxas?: number
fpf_aceita_parcelado?: number
fpf_taxa_mensal?: number
fpf_taxa_transacao?: number
fpf_taxa_transacao_tipo?: number
fpf_parcelas_max?: number
fpf_dias_para_receber?: number
}

registerContract('FormasPagamentoFranquia_SalvarInput', {
  forma_pagamento_id:      { type: 'number',  required: true },
  franquia_id:             { type: 'number',  required: true },
  fpf_possui_taxas:        { type: 'number',  required: false },
  fpf_aceita_parcelado:    { type: 'number',  required: false },
  fpf_taxa_mensal:         { type: 'number',  required: false },
  fpf_taxa_transacao:      { type: 'number',  required: false },
  fpf_taxa_transacao_tipo: { type: 'number',  required: false },
  fpf_parcelas_max:        { type: 'number',  required: false },
  fpf_dias_para_receber:   { type: 'number',  required: false },
})
